<template>
  <v-sheet :light="true">
    <base-assignment
      :available="available"
      :selected="selected"
      :loading="loading"
      :showNewAsCopy="true"
    ></base-assignment>
  </v-sheet>
</template>

<script>
import BaseAssignment from "@/components/BaseAssignment"

export default {
  components: {
    BaseAssignment
  },
  props: {
    courseId: { type: Number }
  },
  data: function() {
    return {
      available: [],
      selected: [],
      loading: true
    }
  },
  created() {
    this.$store
      .dispatch("courses/loadCourse", {
        id: this.courseId,
        showTemplates: true,
        includeHidden: true
      })
      .then(values => {
        this.selected = this.$store.getters["courses/getCourseById"](
          this.courseId
        ).learning_items
        this.available = this.$store.getters[
          "learningItems/getTemplates"
        ].filter(el => {
          return !this.selected.map(el => el.id).includes(el.id)
        })
        this.loading = false
      })
  }
}
</script>
